"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OmnitureHelper = exports.AdobeOmnitureBuilder = void 0;
class AdobeOmnitureBuilder {
    constructor(pageName) {
        this.pageName = pageName;
        this.hitType = AdobeOmnitureBuilder.DEFAULT_VALUE;
        this.pageAction = AdobeOmnitureBuilder.DEFAULT_VALUE;
        this.pageConst = AdobeOmnitureBuilder.DEFAULT_VALUE;
        this.subPageName = AdobeOmnitureBuilder.DEFAULT_VALUE;
        this.refTag = AdobeOmnitureBuilder.DEFAULT_VALUE;
        this.referrer = AdobeOmnitureBuilder.DEFAULT_VALUE;
    }
    withSubPageName(subPageName) {
        this.subPageName = subPageName;
        return this;
    }
    withHitType(hitType) {
        this.hitType = hitType;
        return this;
    }
    withPageAction(pageAction) {
        this.pageAction = pageAction;
        return this;
    }
    withPageConst(pageConst) {
        this.pageConst = pageConst;
        return this;
    }
    withRefTag(refTag) {
        this.refTag = refTag;
        return this;
    }
    withReferrer(referrer) {
        this.referrer = referrer;
        return this;
    }
    build() {
        AdobeOmnitureBuilder.prevPageName = this.pageName;
        return {
            pageName: this.pageName,
            eVar42: this.pageName,
            eVar44: this.subPageName,
            eVar45: this.pageAction
        };
    }
}
exports.AdobeOmnitureBuilder = AdobeOmnitureBuilder;
AdobeOmnitureBuilder.DEFAULT_VALUE = '';
class OmnitureHelper {
    static setOmniturePageInfo(pageInfo) {
        if (OmnitureHelper.hasOmniture(globalThis)) {
            const omniture = globalThis.s;
            omniture.t(pageInfo);
        }
    }
    static hasOmniture(window) {
        return window.s != null;
    }
}
exports.OmnitureHelper = OmnitureHelper;
